import React, { Component } from 'react';
import {Link} from "react-router-dom";
import competences from "../../data/competences";
import BrandIcon from "../shared/BrandIcon";

export default class Competences extends Component {

	render(props) {
		return(
			<>
				{/* Start brands Area */}
				<section className="testimonials_area section-gap">
					<div className="container">
						<div className="row d-flex justify-content-between align-items-end">
							<div className="col-lg-12">
								<div className="section-title">
									<h2>Compétences</h2>
								</div>
							</div>
						</div>

						<div className="d-flex  row justify-content-center flex-wrap">
							{
								competences.map((value, key) => (
									<div className={ `single-brand single-brand-${value._class} p-3` } key={key}>
										<Link to="#"><BrandIcon competence={ value } size="40px" /></Link>
									</div>
								))
							}
						</div>

						<div className="col-lg-12 mt-5">
							<h3 className="text-heading">
								Solutions Logicielles et Applications Métiers
							</h3>

							<h4 className="mb-20">
								J'ai déjà travaillé avec divers IDE (Environnement de Développement Intégré), comme les outils Jetbrains (IntelliJ, Pycharm, PhpStorm),
								mais encore Netbeans, Microsoft Visual Studio et Visual Studio Code
							</h4>

							<h4 className="mb-20">Framework et librairies (déjà utilisé)</h4>

							<div><b>❯ ReactJS</b> (Vous êtes actuellement sur un site web développé avec le framework ReactJS)</div>
							<div><b>❯ NextJS</b></div>
							<div><b>❯ React Native</b></div>
							<div><b>❯ tRPC</b></div>
							<div><b>❯ ExpressJS</b></div>
							<div><b>❯ Bootstrap</b></div>
							<div><b>❯ Symfony</b></div>
							<div><b>❯ Laravel</b></div>
							<div><b>❯ jQuery</b></div>

							<h4 className="mb-20 mt-20">+ Langages et Méthodes</h4>

							<div><b>❯ TypeScript</b></div>
							<div><b>❯ SQL</b> (PostgreSQL, MySQL)</div>
							<div><b>❯ Merise</b></div>
							<div><b>❯ UML</b> (simplifié, diagramme de classe)</div>

							<hr className="mb-3"/>

							<h3 className="text-heading">
								Infrastructure, Systèmes et Réseaux
							</h3>

							<div className="row">
								<div className="col-lg-6">
									<div><b>❯ Virtualisation</b></div>
									<div><b>❯ Architecture du PC</b></div>
									<div><b>❯ Stockage de masse</b></div>
									<div><b>❯ RAID - SAN - NAS</b></div>
									<div><b>❯ Réseaux locaux d'entreprise - Architecture</b></div>
									<div><b>❯ Signaux et unités</b></div>
									<div><b>❯ IPv4</b></div>
									<div><b>❯ Ethernet</b></div>
								</div>
								<div className="col-lg-6">
									<div><b>❯ DHCP</b></div>
									<div><b>❯ Ports applicatifs</b></div>
									<div><b>❯ DNS</b></div>
									<div><b>❯ Active Directory</b></div>
									<div><b>❯ ITIL</b></div>
									<div><b>❯ Gestion des incidents</b></div>
									<div><b>❯ Sécurité</b></div>
									<div><b>❯ Big data</b></div>
								</div>
							</div>

							<h4 className="mb-20 mt-20">Savoir-faire</h4>

							<div className="row">
								<div className="col-lg-6">
									<ul className="unordered-list">
										<li>Installer une machine Linux et Windows</li>
										<li>Linux Server
											<ul>
												<li>Installer & Configurer un serveur web (Apache2)</li>
												<li>Installer & Configurer un serveur FTP</li>
												<li>Installer & Configurer un serveur DNS</li>
											</ul>
										</li>
										<li>
											Windows Server
											<ul>
												<li>Installer & Configurer le service DHCP sous Windows Server 2019</li>
												<li>Installer & Configurer le service DNS sous Windows Server 2019</li>
												<li>Installer & Configurer le service Active Directory sous Windows Server 2019</li>
											</ul>
										</li>
										<li>Faire de la virtualisation avec VMware</li>
									</ul>
								</div>
								<div className="col-lg-6">
									<ul className="unordered-list">
										<li>
											Gestion des disques sous Windows 10
											<ul>
												<li>Partition et Volume</li>
												<li>Cryptage</li>
												<li>Compression des fichiers</li>
											</ul>
										</li>
										<li>
											Gestion des permissions NTFS sous Windows 10
										</li>
										<li>
											TCPIP et Utilitaires sous Windows 10 et Linux Debian
											<ul>
												<li>Gestion d’adresse IP</li>
												<li>Masque de sous-réseau</li>
												<li>Passerelle</li>
												<li>Configuration client DNS</li>
											</ul>
										</li>
									</ul>
								</div>
							</div>
						</div>

					</div>
				</section>
				{/* End brands Area */}
			</>
		)
	}
}